import styled from "styled-components"
import { fontWeight } from "buoy-theme"
import { Link } from "buoy-core"

const AddInfoLink = styled(Link)`
  font-weight: ${props =>
    props.dashboard ? fontWeight.regular : fontWeight.light};
  width: auto;
  line-height: 1.25;
  margin-top: ${props => (props.dashboard ? "0" : "12px")};

  &:last-child {
    margin-bottom: 0;
  }
`

export { AddInfoLink as default }



// WEBPACK FOOTER //
// ./assets/account/components/AddInfoLink.js